export default __webpack_public_path__ + "static/media/modelA-cap.e4451ba8.png";